import axios from 'axios';
import { logout } from '../../features/auth/authSlice';

// 基本配置
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 請求攔截器
api.interceptors.request.use(
  (config) => {
    // 從localStorage獲取令牌並添加到請求頭
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 響應攔截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 處理401未授權錯誤
    if (error.response && error.response.status === 401) {
      // 動態引入 store 以避免循環依賴
      import('../../store').then((storeModule) => {
        // 分發登出操作
        storeModule.default.dispatch(logout());
        // 重定向到登入頁面
        window.location.href = '/login';
      });
    }
    return Promise.reject(error);
  }
);

export default api; 